import { fmt } from '@/lib/api';

export const invoicePayment = d => {
  const credit = Math.abs(Number(d.creditnota_totaal || 0));
  const net = Math.max(0, (d.totaal || 0) - credit);
  const paid = d.betaald_bedrag || 0;
  const balance = net - paid;
  const over = paid > net + 0.02;
  const color = Math.abs(balance) < 0.02 ? '#008A27' : balance < 0 ? '#7C3AED' : '#B91C1C';
  return { credit, net, paid, balance: Math.abs(balance) < 0.02 ? 0 : balance, over, color };
};

export const InvoicePaymentCell = ({ doc: d }) => {
  const { balance, credit, color } = invoicePayment(d);
  return <td className="right invoice-payment-cell" data-testid={`te-betalen-${d.id}`} title={credit > 0 ? `Na aftrek van ${fmt(credit)} creditnota’s` : undefined}>
    <span style={{ color }} data-testid={`invoice-balance-${d.id}`}>{fmt(balance)}</span>
  </td>;
};